// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/opt/buildhome/repo/apps/admin/src/models/useCos';
import model_2 from '/opt/buildhome/repo/apps/admin/src/models/useCountry';
import model_3 from '/opt/buildhome/repo/apps/admin/src/models/useList';
import model_4 from '/opt/buildhome/repo/apps/admin/src/models/useListDetail';
import model_5 from '/opt/buildhome/repo/apps/admin/src/models/usePlay';
import model_6 from '/opt/buildhome/repo/apps/admin/src/models/useSetting';
import model_7 from '/opt/buildhome/repo/apps/admin/src/models/useSubjectAssociation';
import model_8 from '/opt/buildhome/repo/apps/admin/src/models/useTagAssociation';
import model_9 from '/opt/buildhome/repo/apps/admin/src/models/useTopic';
import model_10 from '/opt/buildhome/repo/apps/admin/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'useCos', model: model_1 },
model_2: { namespace: 'useCountry', model: model_2 },
model_3: { namespace: 'useList', model: model_3 },
model_4: { namespace: 'useListDetail', model: model_4 },
model_5: { namespace: 'usePlay', model: model_5 },
model_6: { namespace: 'useSetting', model: model_6 },
model_7: { namespace: 'useSubjectAssociation', model: model_7 },
model_8: { namespace: 'useTagAssociation', model: model_8 },
model_9: { namespace: 'useTopic', model: model_9 },
model_10: { namespace: '@@initialState', model: model_10 },
} as const
